import React from 'react'
import classNames from 'classnames'


export class TripLength extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            tripLength: 0
        }

        this.updateTripLength = this.updateTripLength.bind(this)
    }

    updateTripLength(evt) {
        let length = parseInt(evt.target.dataset.duration)
        this.setState({tripLength: length})
        this.props.onSaveTripLength(length)
        // after setting, continue to next screen
        this.props.progressInitState()
    }

    render() {
        let lengthClasses = (length) => {
            return classNames(
                'btn',
                'btn-medium',
                'btn-radio',
                {active: this.state.tripLength === length}
            )
        }

        return (
            <div className="container-full container-fluid">
                <div className="row">
                    <div className="section-title col-sm-12 welcome-msg">
                        <h1>Welcome to your trip!</h1>
                        <h2>How long are you planning to go on your trip?</h2>
                        <p>It's okay if you don't know, you can modify this at any time.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="section-subtitle col-sm-6 col-sm-offset-3">
                        <span>Select a trip length</span>
                    </div>
                </div>
                <div className="row stacked-blocks">
                    <div className="col-sm-6 col-sm-offset-3">
                        <div
              onClick={this.updateTripLength}
              className={lengthClasses(4)}
              data-duration="4">
              Long Weekend
                        </div>
                        <div
              onClick={this.updateTripLength}
              className={lengthClasses(7)}
              data-duration="7">
              One Week
                        </div>
                        <div
              onClick={this.updateTripLength}
              className={lengthClasses(10)}
              data-duration="10">
              7 - 10 Days
                        </div>
                        <div
              onClick={this.updateTripLength}
              className={lengthClasses(14)}
              data-duration="14">
              2 Weeks
                        </div>
                        <div
              onClick={this.updateTripLength}
              className={lengthClasses(21)}
              data-duration="21">
              21+ Days
                        </div>
                        <div
              onClick={this.updateTripLength}
              className={lengthClasses(1)}
              data-duration="1">
              Not Sure
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
